import toast from 'react-hot-toast'

/**
 * Fila de carga de un documento de flete (SP-221).
 *
 * La usan las dos pantallas donde el proveedor sube facturas —el listado y el
 * detalle de la orden—, que son componentes distintos con el mismo paso. Vive
 * aquí para que no se separen: la primera versión solo estaba en el listado, y
 * desde el detalle el servidor rechazaba la factura pidiendo documentos que esa
 * pantalla nunca ofrecía.
 */
export const ArchivoDeFlete = ({
  etiqueta,
  requerido,
  acepta,
  archivo,
  onElegir,
}: {
  etiqueta: string
  requerido: boolean
  /** Extensiones aceptadas, como las escribe un input: ".pdf" o ".xml". */
  acepta: string
  archivo: File | null
  onElegir: (archivo: File | null) => void
}) => (
  <div>
    <div className="border border-gray-300 rounded-lg p-3 flex items-center justify-between">
      <div className="flex items-center gap-1">
        <span className="text-sm text-gray-700">{etiqueta}</span>
        {requerido ? (
          <span className="text-red-500 font-bold">*</span>
        ) : (
          <span className="text-xs text-gray-500">(opcional)</span>
        )}
      </div>
      <label className="cursor-pointer">
        <input
          type="file"
          accept={acepta}
          onChange={(e) => {
            const elegido = e.target.files?.[0]
            if (!elegido) {
              onElegir(null)
              return
            }
            const formatos = acepta.split(',').map((formato) => formato.trim().toLowerCase())
            if (!formatos.some((formato) => elegido.name.toLowerCase().endsWith(formato))) {
              toast.error(`Formato no válido. Se espera ${formatos.join(' o ')}`)
              return
            }
            onElegir(elegido)
          }}
          className="hidden"
        />
        <span
          className="inline-flex items-center gap-1.5 text-sm font-medium"
          style={{ color: '#315FB9' }}
        >
          Cargar
        </span>
      </label>
    </div>
    {archivo && <p className="text-xs text-gray-600 mt-1 ml-1 truncate">{archivo.name}</p>}
  </div>
)

export default ArchivoDeFlete
